<template>
  <div 
    v-if="slug !== null && slug !== 'error' && pageData"
    class="WijkBeknopt">

    <HeaderSection 
      :title="`Wijk: ${title}`"
      :closeLinkTo="{ name: 'list-wijken' }">
      <p>
        {{ definition }}
      </p>
    </HeaderSection>

    <ContentSection>
      <SectionHeader label="Verhalen" />
      
      <p v-if="items.length === 0">
        Er zijn nog geen verhalen verbonden aan deze wijk. <br />
        Heb jij een goed verhaal om te delen? <br />
        <Link :to="{ name: 'page-aanmaken' }" label="Laat het ons weten!" arrow />
      </p>
    </ContentSection>
    <List 
      :items="items" 
      :sortingBy="sortingBy" 
      type="project"
      readmore="zoom" />
    
  </div>
</template>

<script>
import List from '@/components/lists/List';
import HeaderSection from '@/components/section/HeaderSection';
import SectionHeader from '@/components/section/Header';
import ContentSection from '@/components/section/ContentSection';
import Link from '@/components/Link';

export default {
  name: 'WijkBeknopt',
  components: {
    List,
    HeaderSection,
    SectionHeader,
    ContentSection,
    Link
  },
  data() {
    return {
      slug: null,
      sortingBy: [
        {
          key: 'name',
          label : 'A-Z'
        }
      ]
    }
  },
  computed: {
    pageData() {
      return this.$store.getters.getWijkBySlug({
        slug: this.slug
      });
    },
    title() {
      return this.pageData.name;
    },
    definition() {
      return this.pageData.summary;
    },
    items() {
      let items = this.$store.getters.getProjectsByWijk({id: this.pageData.id});
      items.forEach((item) => {
        item.to = { name: 'project-beknopt', params: { slug: item.slug } };
        return item;
      });
      return items;
    }
  },
  created() {
    this.slug = this.$route.params.slug 
      ? this.$route.params.slug 
      : 'error';
  }
}
</script>

<style lang="scss">
  .WijkBeknopt {
    position: relative;
    display: flex;
    flex-direction: column;

    .ContentSection {
      margin-bottom: 0;
      .SectionHeader {
        margin-bottom: 0;
      }
    }
    .List__items {
      padding-top: 16px !important;
    }
  }
</style>
